module.exports = __webpack_public_path__ + "img/front_range.96d5ab8b.jpg";